import editorWorker from "monaco-editor/esm/vs/editor/editor.worker?worker";

let configured = false;

/** Configure Monaco workers once (Vite). Call before creating any editor. */
export function ensureMonacoEnvironment() {
  if (configured || typeof self === "undefined") return;
  configured = true;
  (self as unknown as { MonacoEnvironment: { getWorker: () => Worker } }).MonacoEnvironment = {
    getWorker() {
      return new editorWorker();
    },
  };
}
